import { isPlatformBrowser } from '@angular/common';
import { DestroyRef, Injectable, InjectionToken, PLATFORM_ID, inject } from '@angular/core';
import { Observable } from 'rxjs';

export const BROADCAST_CHANNEL_NAME = new InjectionToken<string>('BROADCAST_CHANNEL_NAME');

@Injectable()
export class BroadcastChannelService<T = unknown> {
  private readonly channelName = inject(BROADCAST_CHANNEL_NAME);
  private readonly platformId = inject(PLATFORM_ID);
  private readonly destroyRef = inject(DestroyRef);

  private channel: BroadcastChannel | null = null;

  readonly messages$: Observable<T>;

  constructor() {
    if (isPlatformBrowser(this.platformId)) {
      const channel = new BroadcastChannel(this.channelName);
      this.channel = channel;

      this.messages$ = new Observable<T>((subscriber) => {
        const handler = (event: MessageEvent<T>): void => subscriber.next(event.data);

        channel.addEventListener('message', handler);

        return (): void => {
          channel.removeEventListener('message', handler);
        };
      });

      this.destroyRef.onDestroy(() => {
        channel.close();
      });
    } else {
      this.messages$ = new Observable<T>();
    }
  }

  postMessage(data: T): void {
    this.channel?.postMessage(data);
  }
}
